var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 0"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("请选择" + _vm._s(_vm.options.name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "icon": "ios-search",
      "placeholder": _vm.options.placeholder || '输入名称/编码查询...'
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.query.keywords),
      callback: function($$v) {
        _vm.$set(_vm.query, "keywords", $$v)
      },
      expression: "query.keywords"
    }
  }), _vm._v(" "), (_vm.usedKeywords) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": _vm.clearKeywords
    }
  }, [_vm._v(" 搜索：" + _vm._s(_vm.usedKeywords))]) : _vm._e(), _vm._v(" "), (_vm.query.selections) ? _c('Tag', {
    staticStyle: {
      "height": "32px",
      "line-height": "32px",
      "margin": "0"
    },
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        _vm.query.selections = null
        _vm.loadData()
      }
    }
  }, [_vm._v("\n                        仅查看包含在 "), _c('span', {
    staticStyle: {
      "color": "#20bf64"
    }
  }, [_vm._v(_vm._s(_vm.query.selections.length))]), _vm._v(" 个已选项中的内容")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.results.length) ? _c('div', [_c('Table', {
    ref: "sheet",
    attrs: {
      "columns": _vm.columns,
      "loading": _vm.loading,
      "row-class-name": _vm.getRowClass,
      "data": _vm.results
    },
    on: {
      "on-select": _vm.itemSelected,
      "on-row-click": _vm.rowSelected,
      "on-select-cancel": _vm.itemSelectedCancel,
      "on-select-all": _vm.allSelected,
      "on-select-all-cancel": _vm.allSelectedCancel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [_c('div', [(_vm.selections.length || _vm.results.length) ? _c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v("\n                            已选"), _c('span', {
    staticStyle: {
      "color": "#20bf64",
      "margin": "0 4px"
    }
  }, [_vm._v(_vm._s(_vm.selections.length))]), _vm._v("项\n                            "), (_vm.selections.length) ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.showSelections
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.clearSelections
    }
  }, [_vm._v("取消选择")])]) : _vm._e(), _vm._v(" "), (_vm.options.importable) ? [_c('a', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "20px"
    },
    on: {
      "click": _vm.exportSelections
    }
  }, [_vm._v("导出选项")]), _vm._v(" "), _c('Upload', {
    ref: "uploader",
    attrs: {
      "data": _vm.uploadConfig,
      "show-upload-list": false,
      "on-success": _vm.fileUploadSuccess,
      "on-progress": _vm.fileProgress,
      "multiple": "",
      "action": "//upload.qiniup.com/"
    }
  }, [_c('div', {
    on: {
      "click": _vm.refreshUploadToken
    }
  }, [_c('a', {
    staticClass: "hover",
    staticStyle: {
      "color": "#20bf64",
      "margin-left": "20px"
    }
  }, [_vm._v("导入选项")])])])] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.nopage) ? _c('Page', {
    staticStyle: {
      "padding": "16px"
    },
    attrs: {
      "size": "small",
      "placement": "top",
      "total": _vm.total,
      "current": _vm.page.current,
      "page-size": _vm.page.size,
      "show-total": "",
      "show-sizer": "",
      "page-size-opts": [10, 20, 50, 100, 200]
    },
    on: {
      "on-change": _vm.pageChanged,
      "on-page-size-change": _vm.pageSizeChanged
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.results.length) ? _c('div', {
    staticClass: "center",
    staticStyle: {
      "color": "#aaa",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "foot jcsb",
    staticStyle: {
      "padding": "0 20px"
    }
  }, [_c('div', [(!_vm.options.multi && _vm.selections.length > 1) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只能选择1项")]) : (_vm.options.max && _vm.selections.length > _vm.options.max) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只能选择" + _vm._s(_vm.options.max) + "项")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), ((!_vm.options.multi && _vm.selections.length != 1) || (_vm.options.max && _vm.selections.length > _vm.options.max)) ? _c('Button', {
    attrs: {
      "disabled": "",
      "type": "primary"
    }
  }, [_vm._v("确定")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497bc2d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DataSelector.vue
// module id = kQSw
// module chunks = 138